/**************************************************
 * Nombre:       Formulario_Comision
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {Flag, Inventory, InventoryOutlined, Money, MoveUpOutlined} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {TIPOSIMULACIONCONSULTOR, TIPOSIMULACIONDISTRIBUIDOR} from "../../Constantes";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";
import {useContext, useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import {usuarioContext} from "../../App";

const Formulario_Comision = ({...props}) => {
    const cData = useContext(usuarioContext)
    const [zonas, setZonas] = useState([]);
    const [esDistribuidor, setESDistribuidor] = useState(false);

    useEffect(() => {
        obtenerCol('zonas').then((dox) => {
            setZonas(dox.data)
        })

        if (cData.usuario && cData.usuario.rango) {

            if (cData.usuario.rango === "Distribuidor") {
                setESDistribuidor(true)
                props.props.setValue('distribuidor', true)
            } else {
                setESDistribuidor(false)
                props.props.setValue('distribuidor', false)
            }
        } else {
            setESDistribuidor(false)
            props.props.setValue('distribuidor', false)
        }

    }, [cData]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectPropId Icono={Flag} nombre={'Zona de entrega'} dato={'zona'} {...props}
                                         requerido={'El estado es requerido'} datoId={'impuesto'}
                                         propiedadId={'valor'} propiedad={'nombre'}
                                         opciones={zonas}
                    />
                </Grid>

                <Grid container size={esDistribuidor ? 12 : 6}>
                    <IngresoSelect Icono={MoveUpOutlined} nombre={'Tipo de Simulacion'} dato={'tipo'} {...props}
                                   requerido={'El estado es requerido'}
                                   opciones={esDistribuidor ? TIPOSIMULACIONDISTRIBUIDOR.map((it) => it.nombre) :
                                       TIPOSIMULACIONCONSULTOR.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={InventoryOutlined} nombre={'Nombre de producto'} dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={Money} nombre={'Precio de venta USD'} dato={'valor'} {...props}
                    />
                </Grid>

                {esDistribuidor &&
                    <Grid container size={6}>
                        <IngresoDinero Icono={Inventory} nombre={'Precio en bodega USD'} dato={'valorBodega'} {...props}
                        />
                    </Grid>
                }

            </Grid>

        </form>

    )

}
export default Formulario_Comision
